<div class="loader-container">
  <div class="custom-spinner" [innerHTML]="customSpinnerSVG"></div>
</div>
